import apiClient from './client';
import type { User, UserRole } from '@/types/user';
import type { PaginatedResponse } from '@/types/api';

export interface UserListParams {
  page?: number;
  per_page?: number;
  role?: UserRole;
  is_active?: boolean;
}

export interface UserCreateInput {
  email: string;
  password: string;
  full_name: string;
  role: UserRole;
  company_ids?: number[];
}

export interface UserUpdateInput {
  email?: string;
  full_name?: string;
  role?: UserRole;
  is_active?: boolean;
  company_ids?: number[];
}

export interface PasswordChangeInput {
  current_password: string;
  new_password: string;
}

export const usersApi = {
  // ユーザー一覧取得（スーパー管理者のみ）
  getUsers: async (params?: UserListParams): Promise<PaginatedResponse<User>> => {
    const response = await apiClient.get<PaginatedResponse<User>>('/api/users', { params });
    return response.data;
  },

  // ユーザー詳細取得
  getUser: async (id: number): Promise<User> => {
    const response = await apiClient.get<User>(`/api/users/${id}`);
    return response.data;
  },

  // ユーザー作成（スーパー管理者のみ）
  createUser: async (data: UserCreateInput): Promise<User> => {
    const response = await apiClient.post<User>('/api/users', data);
    return response.data;
  },

  // ユーザー更新
  updateUser: async (id: number, data: UserUpdateInput): Promise<User> => {
    const response = await apiClient.patch<User>(`/api/users/${id}`, data);
    return response.data;
  },

  // ユーザー削除（スーパー管理者のみ）
  deleteUser: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/users/${id}`);
  },

  // パスワード変更
  changePassword: async (data: PasswordChangeInput): Promise<void> => {
    await apiClient.post('/api/users/change-password', data);
  },

  // ユーザーの担当法人割り当て
  assignCompanies: async (userId: number, companyIds: number[]): Promise<void> => {
    await apiClient.post(`/api/users/${userId}/companies`, { company_ids: companyIds });
  },
};
